export default import.meta.ROLLUP_FILE_URL_pADEGV0e5Qot5ZhzD_GrLg;